import enUS from './en-US'
import frFR from './fr-FR'

export default {
  'en-US': Object.assign({}, enUS),
  'fr-FR': Object.assign({}, frFR)
}
